import { toast } from 'react-toastify';

const clicktohide = () => {
    document.body.addEventListener("click",() => {
        toast.dismiss()
    });
}

export default clicktohide;